module.exports = __webpack_public_path__ + "static/media/AbcLogo.35a58c9d.png";